import { useQuery } from "@tanstack/react-query";
import { historyLogApi } from "../../../modules/historylog/api";
import { EntityObject, PageRequest } from "../../types";

export const HISTORY_LOG_QUERY_KEYS = {
  getHistoryLogForAgent: (payload: EntityObject<PageRequest>) => ["getHistoryLogForAgent", payload],
  getHistoryLogForContract: (payload: EntityObject<PageRequest>) => ["getHistoryLogForContract", payload],
};

export const useGetHistoryLogForAgent = (payload: EntityObject<PageRequest>) => {
  return useQuery({
    queryKey: HISTORY_LOG_QUERY_KEYS.getHistoryLogForAgent(payload),
    queryFn: async () => {
      const { data } = await historyLogApi.getHistoryLogForAgent(payload);

      return data;
    },
  });
};

export const useGetHistoryLogForContract = (payload: EntityObject<PageRequest>) => {
  return useQuery({
    queryKey: HISTORY_LOG_QUERY_KEYS.getHistoryLogForContract(payload),
    queryFn: async () => {
      const { data } = await historyLogApi.getHistoryLogForContract(payload);

      return data;
    },
  });
};
